module.exports = __webpack_public_path__ + "static/pos-46b6b61b885d7fcb1f79d65e993fe1d6.webp";